import React, { Fragment, useEffect } from 'react';
import Cookies from 'js-cookie';
import { useHistory } from "react-router-dom";
import { properties } from '../properties';
import $ from "jquery";

function CookieParse() {
    let responseBody = [];
    var json = Cookies.get('response-data');
    const history = useHistory();
    var jsonresponse;
    var responseTitle;
    try {
        json = atob(json);
        jsonresponse = JSON.parse(json);
        let wpg_operation = jsonresponse.operation;
        var digest = "";
        responseTitle = properties.HTTP_RESPONSE_TITLE[jsonresponse.operation];
        for (var property in properties.md5_digest[wpg_operation]) {
            if (jsonresponse[properties.md5_digest[wpg_operation][property]]) {
                digest += jsonresponse[properties.md5_digest[wpg_operation][property]];
            }
        }
        var fieldName;
        for (var outfield in properties.output_params[wpg_operation]) {
            fieldName = properties.output_params[wpg_operation][outfield];
            if (fieldName === properties.RESPONSE_APP_ID_FIELDNAME) {
                fieldName = properties.NEW_RESPONSE_APP_ID_FIELDNAME;
            }
            responseBody.push(
                <div className="form-group" key={outfield}>
                    <div className="control-label ">
                        {fieldName}
                    </div>
                    <div className="col-sm-5">
                        <div className="response-form-control"> {jsonresponse[properties.output_params[wpg_operation][outfield]]} </div>
                    </div>
                </div>
            );
        }
        var md5 = require('md5');
        var security_check;
        console.log(`%cCalculated digest string -> %c${digest}`, 
            "font-weight: bold;", "color: #7f5ff1ff; font-weight: bold;");
        console.log(`%cRecieved security -> %c${jsonresponse["security"]}`,
            "font-weight: bold;", "color: #3cf069ff; font-weight: bold;"
        );
        console.log(`%cGenerated MD5 Hash -> %c${md5(digest + properties.PASSWORD)}`,
            "font-weight: bold;", "color: #f03c5a; font-weight: bold;");
        var sha256 = require('js-sha256');
        if (properties.INTERAVTIVE_OPERATIONS.includes(wpg_operation)) {
            console.log(`%cGenerated sha256 Hash -> %c${sha256(digest + properties.PASSWORD)}`,
                "font-weight: bold;", "color: #b43cf0; font-weight: bold;");
        }
        if (md5(digest + properties.PASSWORD) === jsonresponse["security"]) {
            security_check = properties.SECURITY_CHECK_PASS;
        } else {
            security_check = properties.SECURITY_CHECK_FAIL;
        }
        var sha256_security_check;
        if (sha256(digest + properties.PASSWORD) === jsonresponse["security"]) {
            sha256_security_check = properties.SECURITY_CHECK_PASS;
        } else {
            sha256_security_check = properties.SECURITY_CHECK_FAIL;
        }
        responseBody.push(
            <Fragment key="securityKey">
                <div className="form-group" key="security">
                    <div className="control-label ">
                        security
                    </div>
                    <div className="col-sm-5">
                        <div className="response-form-control"> {jsonresponse["security"]} </div>
                    </div>
                </div>
                <div className="form-group" key="md5-security-check">
                    <div className="control-label ">
                        MD5 Security Check
                    </div>
                    <div className="col-sm-5">
                        <div className="response-form-control"> {security_check} </div>
                    </div>
                </div>
            </Fragment>
        );
        if (properties.INTERAVTIVE_OPERATIONS.includes(wpg_operation)) {
            responseBody.push(
                <Fragment key="SHA256SecurityCheck">
                    <div className="form-group" key="sha256-security-check">
                        <div className="control-label ">
                            SHA-256 Security Check
                        </div>
                        <div className="col-sm-5">
                            <div className="response-form-control"> {sha256_security_check} </div>
                        </div>
                    </div>
                </Fragment>
            )};
    }
    catch {
        responseTitle = "Parse Error"
        responseBody.push(
            <div className="form-group" >
                <div className="col-sm-5">
                    <p className="response-form-control"> {jsonresponse} </p>
                </div>
            </div>);
    }

    if (!Cookies.get("response-data")) {
        history.goBack();
    }

    function replaceHistory() {
        history.replace("/http");
    }

    useEffect(() => {
        if (jsonresponse && document.getElementsByClassName(jsonresponse.operation)[0]) {
            document.getElementsByClassName(jsonresponse.operation)[0].classList.add("active");
        }
        Cookies.remove("response-data");
        $(".page-body").scrollTop(0);
    }, [jsonresponse])


    return (
        <div className="uioperation-response">
            <h2>{responseTitle}</h2>
            {responseBody}
            <div className="form-group">
                <div className="col-sm-5">
                    <button type="submit" className="btn btn-primary" onClick={replaceHistory}>Back</button>
                </div>
            </div>
        </div>
    );
}

export default CookieParse;